import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, Alert } from 'reactstrap'
import { WORKSPACE_MENU_ITEMS_QUERY } from '../../graphql.js'
import WorkspaceMenuItem from '../WorkspaceMenuItem/WorkspaceMenuItem'
import { FaHammer } from 'react-icons/fa'
import { getLoginItem, handleGraphQLErrors, makeInteger } from '../../utils'
import './WorkspaceMenu.css'

export const WORKSPACE_MENU_ITEMS = gql(WORKSPACE_MENU_ITEMS_QUERY)

export default function WorkspaceMenu() {
  console.log('WorkspaceMenu rendered')

  const currentWorkspaceId = getLoginItem('currentWorkspaceId')
  let currentWorkspaceName = null
  const [items, setItems] = useState([])
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    let mounted = true
    async function fetchItems() {
      try {
        const { data, errors } = await window.apolloClient.query({ query: WORKSPACE_MENU_ITEMS })
        if (data.workspaceMenuItems) {
          const menuItems = []
          for (let item of data.workspaceMenuItems) {
            menuItems.push(<WorkspaceMenuItem key={item.id} item={item}>item.name</WorkspaceMenuItem>)
          }
          if (mounted) {
            setItems(menuItems)
          }
        }
        if (errors) {
          setGraphQLErrors(errors)
        }
      } catch (err) {
        handleGraphQLErrors(err, setGraphQLErrors)
      }
    }
    fetchItems()
    return (() => mounted = false)
  }, [])

  for (let item of items) {
    if (makeInteger(item.props.item.id) === makeInteger(currentWorkspaceId)) {
      currentWorkspaceName = item.props.item.name
    }
  }

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  }
  if (items.length < 2) {
    return (
      <b className="workspace-menu-single-workspace-name" data-cy="workspace-menu"><FaHammer className="workspace-icon" /> {currentWorkspaceName}</b>
    )
  }

  return (
    <UncontrolledDropdown nav inNavbar>
      <DropdownToggle nav caret data-cy="workspace-menu">
        <b><FaHammer className="workspace-icon" /> {currentWorkspaceName}</b>
      </DropdownToggle>
      <DropdownMenu className="workspace-menu">
        {items}
      </DropdownMenu>
    </UncontrolledDropdown>
  )
}
